import gql from 'graphql-tag';

const GET_PROJECT_CATEGORIES = gql`
  query getProjectCategories (
    $projectId: Float!
  ) {
    getProjectCategories (projectId: $projectId) {
      id
      orgId
      projectId
      parentId
      name
      path
      sortOrder
      level
      createdAt
      updatedAt
    }
  }
`;

export default GET_PROJECT_CATEGORIES;
